/**
 * Posnet (Yapi Kredi) Error Code Mapping
 * Provides user-friendly titles and detailed descriptions for payment errors.
 */

const POSNET_ERRORS = {
  // --- Bank and Card Status Errors ---
  "0001": {
    title: "BANKANIZI ARAYIN",
    description: "Kart bu tip işleme izin vermiyor veya kartın kredisi yetersiz. Lütfen kartı veren bankayı arayın.",
  },
  "0004": {
    title: "KART BLOKE EDİLDİ",
    description: "Kartınız bloke edilmiş durumdadır. Lütfen bankanızla iletişime geçin.",
  },
  "0005": {
    title: "KART BİLGİLERİ HATALI",
    description: "Kart numarası, son kullanma tarihi veya güvenlik kodu (CVV) hatalı girilmiş olabilir. Bilgilerinizi kontrol edip tekrar deneyin.",
  },
  "0007": {
    title: "KART KULLANIMA KAPALI",
    description: "Kartınız bloke, çalıntı veya kayıp statüsünde olabilir. Lütfen bankanızı arayın.",
  },
  "0012": {
    title: "GEÇERSİZ İŞLEM",
    description: "Hatalı taksit sayısı veya kartın desteklemediği bir işlem türü seçilmiş olabilir. Lütfen bilgilerinizi kontrol edin.",
  },
  "0014": {
    title: "GEÇERSİZ KART NUMARASI",
    description: "Girilen numara bir kredi kartına ait değil veya kart numarası hatalı.",
  },
  "0015": {
    title: "İŞLEM YETKİSİ YOK",
    description: "Terminal veya işyeri yetkisi bu işlem için uygun değil ya da taksit için yetersiz tutar.",
  },
  "0030": {
    title: "BANKA SİSTEM HATASI",
    description: "Kartı veren banka sisteminden kaynaklı bir veri hatası oluştu. Lütfen bankanızla görüşün.",
  },
  "0041": {
    title: "KAYIP KART BİLDİRİMİ",
    description: "Kayıp kart bildirimi mevcut. Lütfen bankanızla iletişime geçin.",
  },
  "0043": {
    title: "KART ÇALINTI BİLDİRİMİ",
    description: "Kartın çalıntı listesinde olması nedeniyle işlem reddedildi. Lütfen bankanızı arayın.",
  },
  "0051": {
    title: "BAKİYE YETERSİZ",
    description: "Kartın bakiyesi yetersiz. Lütfen limitinizi kontrol edin veya başka bir kart deneyin.",
  },
  "0053": {
    title: "HESAP BULUNAMADI",
    description: "Hesap bulunamadı. Lütfen bankanızla iletişime geçin.",
  },
  "0054": {
    title: "KARTIN SÜRESİ DOLMUŞ",
    description: "Son kullanım tarihi geçmiş bir kart kullandınız. Lütfen kartınızı kontrol edin.",
  },
  "0057": {
    title: "E-TİCARET YETKİSİ YOK",
    description: "Kartınızın internetten alışveriş (e-ticaret) yetkisi kapalıdır. Bankanızın mobil uygulamasından yetkiyi açabilirsiniz.",
  },
  "0058": {
    title: "İŞLEM TİPİ YETKİSİ YOK",
    description: "Terminalin bu işlem tipine yetkisi bulunmuyor.",
  },
  "0062": {
    title: "KISITLI KART",
    description: "Kısıtlı kart kullanımı. Lütfen bankanızla görüşün.",
  },
  "0065": {
    title: "İŞLEM LİMİTİ AŞILDI",
    description: "Kredi kartının işlem veya para çekme limiti aşılmış olabilir.",
  },
  "0091": {
    title: "BANKA ZAMAN AŞIMI",
    description: "Banka sistemi ile iletişimde zaman aşımı oluştu. Lütfen bir süre sonra tekrar deneyin.",
  },

  // --- Host and Database Errors ---
  "0100": {
    title: "BANKA BAĞLANTI SORUNU",
    description: "Banka sisteminde anlık bir sorun oluştu. Lütfen tekrar deneyin.",
  },
  "0122": {
    title: "KAYIT BULUNAMADI",
    description: "İptal veya iade işlemi için gerekli kayıt bulunamadı.",
  },
  "0123": {
    title: "İŞLEM BULUNAMADI",
    description: "Finansallaştırma veya iptal edilmeye çalışılan orijinal işlem bulunamadı.",
  },
  "0124": {
    title: "SİSTEMSEL KESİNTİ",
    description: "Banka sistemlerinde çalışma nedeniyle anlık kesinti yaşanıyor olabilir. Lütfen daha sonra tekrar deneyin.",
  },
  "0127": {
    title: "GEÇERSİZ SİPARİŞ NUMARASI",
    description: "Bu sipariş numarası (Order ID) daha önce kullanılmış. Lütfen yeni bir işlem başlatın.",
  },
  "0129": {
    title: "KART ENGELLENDİ",
    description: "Bu kredi kartı işyeri karalistesine alınmıştır.",
  },

  // --- Configuration and User Errors ---
  "0146": {
    title: "YETKİLENDİRME HATASI",
    description: "Kullanıcı adı, şifre veya şifreleme anahtarı hatası. Teknik destek ile iletişime geçin.",
  },
  "0148": {
    title: "TERMİNAL TANIM HATASI",
    description: "Üye işyeri numarası (MID), terminal ID (TID) veya IP adresi hatası. Teknik destek ile iletişime geçin.",
  },
  "0150": {
    title: "GÜVENLİK KODU (CVC) HATALI",
    description: "Kartın arkasındaki 3 haneli güvenlik kodu hatalı girilmiş.",
  },

  // --- Invalid Transaction and Limit Errors ---
  "0200": {
    title: "GEÇERSİZ İŞLEM TALEBİ",
    description: "Yapılmaya çalışılan işlem şu anki durum için uygun değildir.",
  },
  "0205": {
    title: "GEÇERSİZ İŞLEM TUTARI",
    description: "İşlem tutarı limitleri aşıyor veya iade tutarı orijinal tutardan büyük.",
  },
  "0211": {
    title: "İŞLEM İPTAL EDİLEMEZ",
    description: "İşlem finansallaştığı için artık iptal edilemez, iade işlemi yapılmalıdır.",
  },
  "0217": {
    title: "GEÇERSİZ İŞLEM STATÜSÜ",
    description: "Banka tarafından geçersiz işlem statüsü bildirilmiştir.",
  },
  "0220": {
    title: "ZATEN İPTAL EDİLMİŞ",
    description: "Bu işlem daha önce iptal edilmiştir.",
  },
  "0232": {
    title: "GÜNLÜK İŞLEM SINIRI AŞILDI",
    description: "Bu kart ile belirli bir periyotta yapılabilecek maksimum işlem sayısı aşılmıştır.",
  },
  "0400": {
    title: "POSNET SUNUCU HATASI",
    description: "Posnet sunucusu teknik bir sorun yaşıyor. Lütfen teknik destek ile iletişime geçin.",
  },
  "0788": {
    title: "İŞLEM ZATEN ONAYLI",
    description: "Bu işlem zaten başarıyla tamamlanmış.",
  },

  // --- Custom and Specific Messages ---
  "3d_failed": {
    title: "3D SECURE ONAYLANMADI",
    description: "3D Secure doğrulaması başarısız oldu veya kart sahibi işlemi onaylamadı.",
  },
  "mac_failed": {
    title: "GÜVENLİK DOĞRULAMA HATASI",
    description: "İşlem güvenliği (MAC) doğrulaması başarısız oldu.",
  },
};

// Common string-to-code mapping
const STRING_MAPPINGS = {
  "onaylanmadi": "0005",
  "limit yetersiz": "0051",
  "paket hatali (ccno)": "0150",
  "ecom yetki kapali": "0057",
  "suresi dolmus kart": "0054",
  "2:cardholder_not_found": "0053",
  "3d_failed": "3d_failed",
  "mac_failed": "mac_failed",
};

/**
 * Resolves a human-readable error title and description.
 * @param {string} code - The error code (e.g., "0051" or "51")
 * @param {string} text - The raw error text (e.g., "Limit Yetersiz")
 * @returns {Object} - { title, description }
 */
export const resolvePosnetError = (code, text) => {
  const rawCode = String(code || "").trim();
  const normalizedCodePadded = rawCode.padStart(4, "0");
  
  // Normalize text for matching (handle Turkish characters specifically just in case)
  const normalizeForMatch = (str) => {
    return String(str || "")
      .replace(/İ/g, "i")
      .replace(/I/g, "ı")
      .toLowerCase()
      .trim();
  };

  const normalizedText = normalizeForMatch(text);

  // 1. Try matching by code directly (padded)
  if (POSNET_ERRORS[normalizedCodePadded]) {
    return POSNET_ERRORS[normalizedCodePadded];
  }

  // 2. Try matching by code directly (unpadded)
  if (POSNET_ERRORS[rawCode]) {
    return POSNET_ERRORS[rawCode];
  }

  // 3. Try matching the text in STRING_MAPPINGS
  const mappedCode = STRING_MAPPINGS[normalizedText];
  if (mappedCode && POSNET_ERRORS[mappedCode]) {
    return POSNET_ERRORS[mappedCode];
  }

  // 4. Try matching without Turkish adjustments if above failed
  const simpleText = String(text || "").toLowerCase().trim();
  const simpleMappedCode = STRING_MAPPINGS[simpleText];
  if (simpleMappedCode && POSNET_ERRORS[simpleMappedCode]) {
    return POSNET_ERRORS[simpleMappedCode];
  }

  // Last fallback: return the raw text or default
  return {
    title: text || "İşlem Reddedildi",
    description: "Ödeme işlemi banka tarafından onaylanmadı. Lütfen bilgilerinizi kontrol edip tekrar deneyin veya bankanızla iletişime geçin.",
  };
};

export default POSNET_ERRORS;
